export const COEFFICIENTS = {
  age: -0.0474,
  sex: 0.2719,
  nstemi: 1.1850,
  eGFR: -0.0277,
  hemo: -0.0169,
  albuminuriaMild: 0.1199,
  albuminuriaHEavy: 0.9289,
  diabetes: 1.0421,
  priorInv: -0.0294,
  interceptTerm: -7.8995
};

export const BASELINES = {
  age: -77.14,
  eGFR: -51.41,
  hemo: -126.74
};

export const FACTOR = {
  conservativeMgmt: 1 / 1.20
};
